export const DEFAULT_SEARCH_MIN_LENGTH = 3;
export const DEFAULT_SEARCH_PLACEHOLDER = 'Search';
export const DEFAULT_VALID_REGEX = /^[a-z0-9@._]+$/i;
